import { createSelector } from '@reduxjs/toolkit';
import { selectIsNotLastFloor } from 'shared/selectors/jsonQuery';

export const selectOnlyLastFloorFilter = createSelector(selectIsNotLastFloor, value => ({
  label: 'Только последний',
  value: value === false,
}));
